import { render, staticRenderFns } from "./AdminCompanies.vue?vue&type=template&id=33e9c154&scoped=true"
import script from "./AdminCompanies.vue?vue&type=script&lang=js"
export * from "./AdminCompanies.vue?vue&type=script&lang=js"
import style0 from "./AdminCompanies.vue?vue&type=style&index=0&id=33e9c154&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e9c154",
  null
  
)

export default component.exports